export default __webpack_public_path__ + "static/media/Security.9fc7f1a6.png";